import strings from 'strings';

export const COPIES = strings.inventory.quickEntry.drawers.candidate;
export const DELETE_API_VERSION = 1;

export const FORM_FIELDS = {
  name: 'name',
  notes: 'notes',
  files: 'files'
};

export const DEFAULT_FORM_VALUES = {
  [FORM_FIELDS.name]: '',
  [FORM_FIELDS.notes]: COPIES.notesTemplate,
  [FORM_FIELDS.files]: {}
};

export const UPLOAD_CATEGORIES = [
  { id: 46, title: COPIES.uploads.resume },
  { id: 47, title: COPIES.uploads.candidateDataSheet },
  { id: 48, title: COPIES.uploads.handwrittenNotes }
];
